(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("SelectIconsModalCtrl", ["$scope", "$http", "activeIcon", selectIconsModalCtrl]);
    function selectIconsModalCtrl($scope, $http, activeIcon) {
        var vm = this;
        vm.loading = true;
        vm.selectedIcon = activeIcon;
        $http.get("app/learningPaths/icons.json")
            .then(function (response) {
            vm.icons = response.data;
            vm.loading = false;
        }).catch(angular.noop);
        vm.selectIcon = function (icon) {
            $scope.$close(icon);
        };
    }
    ;
}());
